import { CustomPredict } from '../CustomPredict';

export function CustomPredictTab() {
  return <CustomPredict />;
}
